module.exports = __webpack_public_path__ + "img/icon_09.e20a9da8.png";